import { render } from "./BaseBadge.vue?vue&type=template&id=4ca52f1c&scoped=true"
const script = {}

import "./BaseBadge.vue?vue&type=style&index=0&id=4ca52f1c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca52f1c"]])

export default __exports__